module.exports = __webpack_public_path__ + "static/Roboto-Regular-subset-59864a6cb2e1bee373d9300b77e0a92f.woff2";